import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { MODAL_SMALL_SCREEN } from '@/components/organisms/Modals/ModalConductor';
import { pushModal } from '@/redux/modals/actions';
import { selectIframeView } from '@/redux/user/selectors';

import { useBreakpoint } from './useBreakpoint';
import useUser from './useUser';

export const useMobileWarning = () => {
  const dispatch = useDispatch();
  const isIframeView = useSelector(selectIframeView);
  const { user } = useUser();
  const isSmallScreen = useBreakpoint('lg');
  const hasChecked = useRef(false);

  useEffect(() => {
    if (hasChecked.current) {
      return;
    }
    // Wait for the user query to resolve before arming the one-shot latch.
    if (!user) {
      return;
    }
    hasChecked.current = true;

    if (isSmallScreen && !isIframeView) {
      dispatch(pushModal(MODAL_SMALL_SCREEN));
    }
  }, [dispatch, isIframeView, user, isSmallScreen]);
};
